'use client';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const BreadCrumb = ({ title, mainLinkTitle, mainLinkUrl, activeLink }) => {
  return (
    <>
      <style jsx>{`
        .breadcrumb-container {
          margin: 16px 0 8px 0;
        }

        .breadcrumb-minimal {
          background: transparent;
          padding: 12px 0;
          border-bottom: 1px solid #f1f5f9;
        }

        .breadcrumb-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }

        .page-title-minimal {
          color: #1e293b;
          font-size: 20px;
          font-weight: 600;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .title-accent {
          width: 3px;
          height: 20px;
          background: #1e3a8a;
          border-radius: 2px;
        }

        .breadcrumb-nav-minimal {
          display: flex;
          align-items: center;
          gap: 6px;
          margin: 0;
          padding: 0;
          list-style: none;
          font-size: 13px;
        }

        .breadcrumb-link-minimal {
          color: #64748b;
          text-decoration: none;
          transition: color 0.2s ease;
          font-weight: 500;
        }

        .breadcrumb-link-minimal:hover {
          color: #1e3a8a;
          text-decoration: none;
        }

        .breadcrumb-separator {
          color: #cbd5e1;
          font-size: 12px;
          margin: 0 2px;
        }

        .breadcrumb-active-minimal {
          color: #1e293b;
          font-weight: 600;
        }

        @media (max-width: 768px) {
          .breadcrumb-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }

          .page-title-minimal {
            font-size: 18px;
          }

          .breadcrumb-nav-minimal {
            font-size: 12px;
          }
        }

        /* Container padding */
        .container-fluid {
          padding-left: 24px;
          padding-right: 24px;
        }

        @media (max-width: 768px) {
          .container-fluid {
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      `}</style>

      <div className='breadcrumb-container'>
        <div className='container-fluid'>
          <div
            className='breadcrumb-minimal'
            style={{ marginTop: '20px', marginBottom: '20px' }}
          >
            <div className='breadcrumb-content'>
              <h1 className='page-title-minimal'>
                <span className='title-accent'></span>
                {title}
              </h1>
              <nav aria-label='breadcrumb'>
                <ol className='breadcrumb-nav-minimal'>
                  <li>
                    <Link
                      to={`/${mainLinkUrl}`}
                      className='breadcrumb-link-minimal'
                    >
                      {mainLinkTitle ? mainLinkTitle : 'Dashboard'}
                    </Link>
                  </li>
                  <li>
                    <span className='breadcrumb-separator'>•</span>
                  </li>
                  <li>
                    <span className='breadcrumb-active-minimal'>
                      {activeLink}
                    </span>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumb);
